<template>
  <footer class="footer level">
    <div class="level-left">
      <div class="level-item pl-2">
        <p>
          <a
            href="https://mh-conseil.com/conditions-generales-dutilisation-cookies/"
            target="_blank"
            >Conditions générales d'utilisation</a
          >
          - pas de cookies
        </p>
      </div>
    </div>
    <div class="level-right">
      <div class="level-item pr-2">
        <p>
          Copyright <strong>MH-Conseil</strong> {{ getYearNow }} - version
          {{ version }}
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import { version } from "../../package.json";
export default {
  data() {
    return {
      version: version,
    };
  },
  computed: {
    getYearNow() {
      return new Date().getFullYear();
    },
  },
};
</script>
